(function () {
  'use strict';
  var italian = document.documentElement.lang.indexOf('it') === 0;
  var german = document.documentElement.lang.indexOf('de') === 0;
  var preorderText = german ? 'Vorbestellung. Verfügbarkeit und Versand richten sich nach dem angegebenen Erscheinungsdatum. Hinweise zu Widerruf und Rückerstattungen findest du in unseren Bedingungen.' : italian
    ? 'Prodotto in preordine. Disponibilità e spedizione seguono la data indicata. Per recesso e rimborsi consulta le condizioni del negozio.'
    : 'Preorder item. Availability and delivery follow the stated release date. See our store policy for withdrawal and refunds.';
  var labels = {Expansion: 'Espansione', Rarity: 'Rarità', Game: 'Gioco', Category: 'Categoria'};
  function update() {
    // Timesact inserts this block asynchronously. Preserve its purchase controls.
    document.querySelectorAll('.timesact-preorder-description').forEach(function (el) {
      if (el.textContent !== preorderText) el.textContent = preorderText;
    });
    if (italian) document.querySelectorAll('.product__description th, .product__description td').forEach(function (el) {
      var value = el.textContent.trim();
      if (labels[value] && el.children.length === 0) el.textContent = labels[value];
    });
  }
  update();
  var product = document.querySelector('[id^="MainProduct-"]');
  if (product) new MutationObserver(update).observe(product, {childList: true, subtree: true, characterData: true});
})();
